import React, { Component } from "react";
import AvatarEditor from 'react-avatar-editor'
import { Navbar, Icon, Button, TextArea, InputGroup } from "@blueprintjs/core";
import NewCircle from "../containers/NewCircle";

class Onboarding extends Component {
    render() {
        return (
            <div className="app-wrapper">
                <Navbar fixedToTop={true} className="app-navbar onboarding">
                    <div className="main-container small-width flex-center-space-between">
                        <Navbar.Group>
                            <Navbar.Heading>
                                <span className="app-logo" />
                            </Navbar.Heading>
                        </Navbar.Group>
                        <Navbar.Group className="menu-right-side stepper">
                            <div className="onboard-steps">
                                <div className="step passed">
                                    <div className="step-icon">
                                        <Icon
                                            icon="person"
                                            iconSize="16"
                                            className="icon"
                                        />
                                    </div>
                                    <div className="step-label">Account</div>
                                    <div className="step-number">1</div>
                                </div>
                                <div className="step active">
                                    <div className="step-icon">
                                        <Icon
                                            icon="map-marker"
                                            iconSize="16"
                                            className="icon"
                                        />
                                    </div>
                                    <div className="step-label">Location</div>
                                    <div className="step-number">2</div>
                                </div>
                                <div className="step">
                                    <div className="step-icon">
                                        <Icon
                                            icon="globe"
                                            iconSize="16"
                                            className="icon"
                                        />
                                    </div>
                                    <div className="step-label">Co-own</div>
                                    <div className="step-number">3</div>
                                </div>
                            </div>
                        </Navbar.Group>
                    </div>
                </Navbar>
                <section>
                    <div className="main-container small-width">
                        <div className="content-wrapper onboarding"  >
                            <div className="step-counter">step 1/3</div>
                            <h1 className="bp3-heading">Tell us a little bit about yourself</h1>
                            <p>Before you start, please introduce yourself. Any specific hobbies or interests?</p>
                            <form className="onboarding-form">
                                <div className="photo-upload avatar">
                                    <label htmlFor="avatar">
                                        <Icon
                                            icon="person"
                                            iconSize="48"
                                            className="icon"
                                        />
                                        <div>Set your avatar</div>
                                    </label>
                                    <input className="ghost-input" type="file" id="avatar" name="avatar" accept="image/png, image/jpeg"></input>
                                </div>
                                <div className="profile-data">
                                    <AvatarEditor
                                        image="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?h=1200&auto=compress&cs=tinysrgb"
                                        width={164}
                                        height={164}
                                        border={20}
                                        color={[0, 0, 0, 0.2]}
                                        scale={1.2}
                                        rotate={0}
                                        borderRadius={100}
                                        className="avatar-preview"
                                    />
                                    <div className="input-area">
                                        <div className="form-group">
                                            <label htmlFor="first-name">First Name</label>
                                            <InputGroup
                                                type="text"
                                                placeholder="John"
                                                fill={true}
                                                id="first-name"
                                                className="no-icon"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="last-name">Last Name</label>
                                            <InputGroup
                                                type="text"
                                                placeholder="Doe"
                                                fill={true}
                                                id="last-name"
                                                className="no-icon"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="bio">
                                                A little bit about you
                                            </label>
                                            <TextArea
                                                placeholder="Start typing..."
                                                fill={true}
                                                id="bio"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <Button
                                    intent="primary"
                                    className="cta"
                                    fill={true}>
                                    Continue
                                </Button>
                            </form>
                        </div>




                        <div className="content-wrapper onboarding"  >
                            <div className="step-counter">step 2/3</div>
                            <h1 className="bp3-heading">Where are you located?</h1>
                            <p>When you provide your home address we can help you find co-owning circles with the lowest distance from you!</p>
                            <form className="onboarding-form">
                                <div className="form-group">
                                    <InputGroup
                                        type="text"
                                        placeholder="Click to select your location"
                                        fill={true}
                                        id="location"
                                        className="no-icon has-button"
                                        rightElement={
                                            <Button className="input-button right">
                                                <Icon
                                                    icon="locate"
                                                    iconSize="20"
                                                    className="icon"
                                                />
                                            </Button>
                                        }
                                    />
                                </div>
                                <Button
                                    intent="primary"
                                    className="cta"
                                    fill={true}>
                                    Continue
                                </Button>
                            </form>
                        </div>

                        <div className="content-wrapper onboarding">
                            <div className="step-counter">step 3/3</div>
                            <h1 className="bp3-heading">Create your first co-owning circle.</h1>
                            <p>You’ll have it flying in no-time.</p>
                            <NewCircle editCircle={this.props.match.params.editCircle} />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Onboarding;
